import React from "react";

import { Container, ContainerWithTitle, Title, Date, Value, ValueAndImageContainer, PostScriptum } from "./styles";

//Interfaces
import { EstablishmentInfoPropsInterface } from "./interfaces";

const EstablishmentInfo = (props: EstablishmentInfoPropsInterface) => {
    const contentGenerator = () => {
        return props.title ? 
            (
                <ContainerWithTitle>
                    <div className="d-flex flex-column">
                        <Title>{props.title}</Title>
                        <Date>({props.date})</Date>
                    </div>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <Value>{props.money ? `R$ ${props.value != null ? props.value.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "0,00"}` : props.value}</Value>
                        <img id="descriptiveIcon" src={props.img} alt="ícone descritivo"/>
                    </div>
                    <PostScriptum>{props.ps}</PostScriptum>
                </ContainerWithTitle>
            ) : 
            (
                <div className="w-100 h-100">
                    <ValueAndImageContainer>
                        <div>
                            <Value style={{marginBottom: 7}}>{props.money ? `R$ ${props.value.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : props.value}</Value>
                            <Title>{props.titleDown}</Title>
                        </div>
                        <div>
                            <img src={props.img} alt="ícone descritivo"/>
                        </div>
                    </ValueAndImageContainer>
                    <div style={{marginTop: -30, marginLeft: 15}}>
                        {props.ps ? <PostScriptum>{props.ps}</PostScriptum>: null}
                    </div>
                </div>
            )
    }
    
    return(
        <Container>
            {contentGenerator()}
        </Container>
    )
}

export default EstablishmentInfo;